<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopProductCategory"
                    >新建
                    </el-button>
                </div>

                <div class="icon-group">
          <span
              class="icon-box"
              @click="refreshShopProductCategoryList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
                </div>

            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopProductCategoryList"
                row-key="id"
                size="small"
                height="100%"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    min-width="10%"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    prop="categoryName"
                    label="分类名称"
                    min-width="20%"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="分类图片"
                    min-width="20%"
                >
                    <template slot-scope="scop">
                        <el-image
                            @click='updateSrcList(scop.row.categoryPic)'
                            style="width: 30px; height: 30px"
                            :src="scop.row.categoryPic"
                            :preview-src-list="srcList"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sort"
                    label="分类排序"
                    min-width="20%"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    min-width="35%"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopProductCategory(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopProductCategory(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopProductCategory(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopProductCategoryStates[shopProductCategoryState]"
                :visible.sync="showDialog"
                width="400px"
            >
                <div>
                    <el-form
                        :model="shopProductCategory"
                        ref="shopProductCategoryForm"
                        :rules="rules"
                        label-width="80px"
                        :inline="true"
                        size="mini"
                    >
                        <el-form-item
                            label="分类名称"
                            prop="categoryName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopProductCategory.categoryName"
                                :disabled="shopProductCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="分类图片" prop="categoryPic">
                            <el-upload
                                action=""
                                :disabled="shopProductCategoryState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                                style="width: 200px"
                            >
                                <img
                                    v-if="shopProductCategory.categoryPic"
                                    :src="shopProductCategory.categoryPic"
                                    class="avatar"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="分类排序"
                            prop="sort"
                        >
                            <el-input-number
                                style="width: 200px"
                                :disabled="shopProductCategoryState == 'check'"
                                v-model="shopProductCategory.sort"
                                size="small"
                                label=""
                                :min="1"
                                :max="100000"
                                :step="1"
                                :controls="true"
                                controls-position="both"
                            >
                            </el-input-number>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="resetDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopProductCategoryState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { importDate, get, post, postJson, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    data() {
        return {
            queryForm: {},
            loading: false,
            showDialog: false,
            isSearch: false,
            currentUserId: '',
            shopProductCategoryState: 'add',
            shopProductCategoryStates: {
                add: '新建商品分类',
                check: '查看商品分类',
                edit: '修改商品分类'
            },
            multipleSelection: [],
            shopProductCategoryList: [],
            shopProductCategory: {
                id: '', //ID
                categoryName: '', //商品分组名
                categoryPic: '', //类别图片
                sort: '10', //分组排序
            },
            btnLoading: false,
            rules: {
                categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                categoryPic: [
                    { 
                        required: true, 
                        message: '分类图片不能为空', 
                        trigger: 'change' 
                    }
                ],
                sort: [
                    { required: true, message: '分类排序不能为空', trigger: 'blur' },
                    { type: 'number', message: '分类排序必须为数字', trigger: 'blur' }
                ]
            },
            srcList: ['']//大图预览
        };
    },
    created() {
        this.getShopProductCategoryList();
    },
    methods: {
        // 搜索项
        search() {
            this.isSearch = !this.isSearch;
        },
        // 图片预览
        updateSrcList(src) {
            this.srcList[0] = src;
        },
        // 重置弹框
        resetDialog() {
            this.shopProductCategoryState = 'add';
            this.showDialog = false;
            this.shopProductCategory = {
                id: '', //ID
                categoryName: '', //商品分组名
                categoryPic: '', //类别图片
                sort: '10', //分组排序
            };
            this.getShopProductCategoryList();
        },
        // 提交表单
        submitForm() {
            // 手动验证图片字段
            if (!this.shopProductCategory.categoryPic) {
                this.$message({
                    message: '分类图片不能为空',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            
            if (this.shopProductCategoryState == 'add') {
                this.$refs.shopProductCategoryForm.validate((valid) => {
                    if (valid) {
                        postJson(`/ex-shop/ex/shop/order/category/addCategory`, { ...this.shopProductCategory }).then((res) => {
                            if (res.code == 200) {
                                this.$message({
                                    message: res.message,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopProductCategoryState == 'edit') {
                this.$refs.shopProductCategoryForm.validate((valid) => {
                    if (valid) {
                        postJson(`/ex-shop/ex/shop/order/category/updateCategory`, { ...this.shopProductCategory }).then((res) => {
                            if (res.code == 200) {
                                this.$message({
                                    message: res.message,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        // 新增商品分类
        addShopProductCategory() {
            this.showDialog = true;
            this.shopProductCategoryState = 'add';
        },
        // 查看商品分类（回显）
        checkShopProductCategory(shopProductCategoryId) {
            this.currentShopProductCategoryId = shopProductCategoryId;
            this.getShopProductCategoryById();
            this.showDialog = true;
            this.shopProductCategoryState = 'check';
        },
        // 修改商品分类（回显）
        editShopProductCategory(shopProductCategoryId) {
            if (shopProductCategoryId) {
                this.currentShopProductCategoryId = shopProductCategoryId;
                this.getShopProductCategoryById();
            } else {
                const selected = this.multipleSelection[0];
                this.shopProductCategory = {
                    id: selected.id || '',
                    categoryName: selected.categoryName || '',
                    categoryPic: selected.categoryPic || '',
                    sort: selected.sort || '10'
                };
            }

            this.showDialog = true;
            this.shopProductCategoryState = 'edit';
        },
        // 删除商品分类
        deleteShopProductCategory(shopProductCategoryId) {
            let ids = '';
            if (shopProductCategoryId) {
                ids = shopProductCategoryId;
            } else {
                ids = this.multipleSelection.map((shopProductCategory) => shopProductCategory.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    postJson(`/ex-shop/ex/shop/order/category/deleteCategory`, { id:ids }).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                message: res.message,
                                type: 'success',
                                duration: 2000
                            });
                            this.getShopProductCategoryList();
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
        },
        // 刷新商品分类列表
        refreshShopProductCategoryList() {
            this.getShopProductCategoryList();
        },
        // 获取商品分类列表
        getShopProductCategoryList() {
            this.loading = true;
            get(`/ex-shop/ex/shop/order/category/queryAllCategory`).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.shopProductCategoryList = res.data;
                }
            });
        },
        // 获取商品分类详情
        getShopProductCategoryById() {
            get(`/ex-shop/ex/shop/order/category/queryCategoryById`, { id: this.currentShopProductCategoryId }).then((res) => {
                if (res.code == 200) {
                    this.shopProductCategory = res.data;
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        // 上传图片
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.shopProductCategory.categoryPic = res.url;
                    // 触发验证
                    this.$nextTick(() => {
                        if (this.$refs.shopProductCategoryForm) {
                            this.$refs.shopProductCategoryForm.validateField('categoryPic');
                        }
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>

